// src/views/login/LoginPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRoutes from "../../api/apiRoutes";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { saveLogin, decodeJwt } from "../../utils/auth";
import { stopSessionWatch } from "../../utils/sessionManager";

/* =========================
   FUNCIÓN MD5 (SIN LIBRERÍAS)
   ========================= */

function md5(string) {
  function RotateLeft(lValue, iShiftBits) {
    return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
  }

  function AddUnsigned(lX, lY) {
    const lX4 = lX & 0x40000000;
    const lY4 = lY & 0x40000000;
    const lX8 = lX & 0x80000000;
    const lY8 = lY & 0x80000000;
    const lResult = (lX & 0x3fffffff) + (lY & 0x3fffffff);

    if (lX4 & lY4) return lResult ^ 0x80000000 ^ lX8 ^ lY8;
    if (lX4 | lY4) {
      if (lResult & 0x40000000) return lResult ^ 0xc0000000 ^ lX8 ^ lY8;
      return lResult ^ 0x40000000 ^ lX8 ^ lY8;
    }
    return lResult ^ lX8 ^ lY8;
  }

  function F(x, y, z) {
    return (x & y) | (~x & z);
  }
  function G(x, y, z) {
    return (x & z) | (y & ~z);
  }
  function H(x, y, z) {
    return x ^ y ^ z;
  }
  function I(x, y, z) {
    return y ^ (x | ~z);
  }

  function FF(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  }

  function GG(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  }

  function HH(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  }

  function II(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  }

  function ConvertToWordArray(str) {
    let lWordCount;
    const lMessageLength = str.length;
    const lNumberOfWords_temp1 = lMessageLength + 8;
    const lNumberOfWords_temp2 =
      (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
    const lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
    const lWordArray = new Array(lNumberOfWords - 1);
    let lBytePosition = 0;
    let lByteCount = 0;

    while (lByteCount < lMessageLength) {
      lWordCount = (lByteCount - (lByteCount % 4)) / 4;
      lBytePosition = (lByteCount % 4) * 8;
      lWordArray[lWordCount] =
        lWordArray[lWordCount] | (str.charCodeAt(lByteCount) << lBytePosition);
      lByteCount++;
    }

    lWordCount = (lByteCount - (lByteCount % 4)) / 4;
    lBytePosition = (lByteCount % 4) * 8;
    lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
    lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
    lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;

    return lWordArray;
  }

  function WordToHex(lValue) {
    let WordToHexValue = "";
    let WordToHexValue_temp = "";
    let lByte;
    let lCount;

    for (lCount = 0; lCount <= 3; lCount++) {
      lByte = (lValue >>> (lCount * 8)) & 255;
      WordToHexValue_temp = "0" + lByte.toString(16);
      WordToHexValue += WordToHexValue_temp.substr(
        WordToHexValue_temp.length - 2,
        2,
      );
    }
    return WordToHexValue;
  }

  function Utf8Encode(str) {
    str = str.replace(/\r\n/g, "\n");
    let utftext = "";

    for (let n = 0; n < str.length; n++) {
      const c = str.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }

    return utftext;
  }

  let x = [];
  let k, AA, BB, CC, DD, a, b, c, d;

  string = Utf8Encode(string);
  x = ConvertToWordArray(string);

  a = 0x67452301;
  b = 0xefcdab89;
  c = 0x98badcfe;
  d = 0x10325476;

  for (k = 0; k < x.length; k += 16) {
    AA = a;
    BB = b;
    CC = c;
    DD = d;

    a = FF(a, b, c, d, x[k + 0], 7, 0xd76aa478);
    d = FF(d, a, b, c, x[k + 1], 12, 0xe8c7b756);
    c = FF(c, d, a, b, x[k + 2], 17, 0x242070db);
    b = FF(b, c, d, a, x[k + 3], 22, 0xc1bdceee);
    a = FF(a, b, c, d, x[k + 4], 7, 0xf57c0faf);
    d = FF(d, a, b, c, x[k + 5], 12, 0x4787c62a);
    c = FF(c, d, a, b, x[k + 6], 17, 0xa8304613);
    b = FF(b, c, d, a, x[k + 7], 22, 0xfd469501);
    a = FF(a, b, c, d, x[k + 8], 7, 0x698098d8);
    d = FF(d, a, b, c, x[k + 9], 12, 0x8b44f7af);
    c = FF(c, d, a, b, x[k + 10], 17, 0xffff5bb1);
    b = FF(b, c, d, a, x[k + 11], 22, 0x895cd7be);
    a = FF(a, b, c, d, x[k + 12], 7, 0x6b901122);
    d = FF(d, a, b, c, x[k + 13], 12, 0xfd987193);
    c = FF(c, d, a, b, x[k + 14], 17, 0xa679438e);
    b = FF(b, c, d, a, x[k + 15], 22, 0x49b40821);

    a = GG(a, b, c, d, x[k + 1], 5, 0xf61e2562);
    d = GG(d, a, b, c, x[k + 6], 9, 0xc040b340);
    c = GG(c, d, a, b, x[k + 11], 14, 0x265e5a51);
    b = GG(b, c, d, a, x[k + 0], 20, 0xe9b6c7aa);
    a = GG(a, b, c, d, x[k + 5], 5, 0xd62f105d);
    d = GG(d, a, b, c, x[k + 10], 9, 0x02441453);
    c = GG(c, d, a, b, x[k + 15], 14, 0xd8a1e681);
    b = GG(b, c, d, a, x[k + 4], 20, 0xe7d3fbc8);
    a = GG(a, b, c, d, x[k + 9], 5, 0x21e1cde6);
    d = GG(d, a, b, c, x[k + 14], 9, 0xc33707d6);
    c = GG(c, d, a, b, x[k + 3], 14, 0xf4d50d87);
    b = GG(b, c, d, a, x[k + 8], 20, 0x455a14ed);
    a = GG(a, b, c, d, x[k + 13], 5, 0xa9e3e905);
    d = GG(d, a, b, c, x[k + 2], 9, 0xfcefa3f8);
    c = GG(c, d, a, b, x[k + 7], 14, 0x676f02d9);
    b = GG(b, c, d, a, x[k + 12], 20, 0x8d2a4c8a);

    a = HH(a, b, c, d, x[k + 5], 4, 0xfffa3942);
    d = HH(d, a, b, c, x[k + 8], 11, 0x8771f681);
    c = HH(c, d, a, b, x[k + 11], 16, 0x6d9d6122);
    b = HH(b, c, d, a, x[k + 14], 23, 0xfde5380c);
    a = HH(a, b, c, d, x[k + 1], 4, 0xa4beea44);
    d = HH(d, a, b, c, x[k + 4], 11, 0x4bdecfa9);
    c = HH(c, d, a, b, x[k + 7], 16, 0xf6bb4b60);
    b = HH(b, c, d, a, x[k + 10], 23, 0xbebfbc70);
    a = HH(a, b, c, d, x[k + 13], 4, 0x289b7ec6);
    d = HH(d, a, b, c, x[k + 0], 11, 0xeaa127fa);
    c = HH(c, d, a, b, x[k + 3], 16, 0xd4ef3085);
    b = HH(b, c, d, a, x[k + 6], 23, 0x04881d05);
    a = HH(a, b, c, d, x[k + 9], 4, 0xd9d4d039);
    d = HH(d, a, b, c, x[k + 12], 11, 0xe6db99e5);
    c = HH(c, d, a, b, x[k + 15], 16, 0x1fa27cf8);
    b = HH(b, c, d, a, x[k + 2], 23, 0xc4ac5665);

    a = II(a, b, c, d, x[k + 0], 6, 0xf4292244);
    d = II(d, a, b, c, x[k + 7], 10, 0x432aff97);
    c = II(c, d, a, b, x[k + 14], 15, 0xab9423a7);
    b = II(b, c, d, a, x[k + 5], 21, 0xfc93a039);
    a = II(a, b, c, d, x[k + 12], 6, 0x655b59c3);
    d = II(d, a, b, c, x[k + 3], 10, 0x8f0ccc92);
    c = II(c, d, a, b, x[k + 10], 15, 0xffeff47d);
    b = II(b, c, d, a, x[k + 1], 21, 0x85845dd1);
    a = II(a, b, c, d, x[k + 8], 6, 0x6fa87e4f);
    d = II(d, a, b, c, x[k + 15], 10, 0xfe2ce6e0);
    c = II(c, d, a, b, x[k + 6], 15, 0xa3014314);
    b = II(b, c, d, a, x[k + 13], 21, 0x4e0811a1);
    a = II(a, b, c, d, x[k + 4], 6, 0xf7537e82);
    d = II(d, a, b, c, x[k + 11], 10, 0xbd3af235);
    c = II(c, d, a, b, x[k + 2], 15, 0x2ad7d2bb);
    b = II(b, c, d, a, x[k + 9], 21, 0xeb86d391);

    a = AddUnsigned(a, AA);
    b = AddUnsigned(b, BB);
    c = AddUnsigned(c, CC);
    d = AddUnsigned(d, DD);
  }

  return (
    WordToHex(a) +
    WordToHex(b) +
    WordToHex(c) +
    WordToHex(d)
  ).toLowerCase();
}
/* =========================
   COMPONENTE LOGIN
   ========================= */

function LoginPage() {
   

  useEffect(() => {
    stopSessionWatch();

    localStorage.clear();
    sessionStorage.clear();

    if ("caches" in window) {
      caches.keys()
        .then((names) => {
          names.forEach((name) => caches.delete(name));
        })
        .catch(() => {});
    }
  }, []);


  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [error, setError] = useState("");
  const [mostrarClave, setMostrarClave] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!usuario.trim() || !clave.trim()) {
      setError("Por favor, completá usuario y clave");
      return;
    }

    try {
      // 1️⃣ pedir challenge
      const challengeResp = await fetch(apiRoutes.login.challenge, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario }),
      });

      if (!challengeResp.ok) {
        throw new Error("No se pudo obtener challenge");
      }

      const { challenge } = await challengeResp.json();

      // 2️⃣ calcular hashes
      const passwordHash = md5(clave);
      const responseHash = md5(passwordHash + challenge);

      //console.log("MD5(password):", passwordHash);
      //console.log("MD5(password + challenge):", responseHash);

      // 3️⃣ login
      const response = await fetch(apiRoutes.login.auth, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          usuario,
          challenge,
          response: responseHash,
        }),
      });

      if (!response.ok) {
        if (response.status === 404) {
          const body = await response.json().catch(() => null);
          const msg =
            body?.error_description ||
            "Tu usuario está bloqueado. Comunicate con soporte técnico.";
          setError(msg);
          return;
        }

        if (response.status === 401) {
          const body = await response.json().catch(() => null);
          const msg = body?.error_description || "Usuario o clave incorrectos";
          setError(msg);
          return;
        }

        throw new Error("No se pudo iniciar sesión.");
      }

      const data = await response.json();

      const loginOk = saveLogin(data);

      if (!loginOk) {
        setError("No se pudo iniciar sesión. El token recibido es inválido.");
        return;
      }

      const claims = decodeJwt(data?.access_token);

      if (!claims) {
        setError("No se pudo iniciar sesión. Token inválido.");
        return;
      }

      if (claims) {
        localStorage.setItem("claims", JSON.stringify(claims));
        if (claims.role) localStorage.setItem("role", claims.role);
        if (claims.actorType)
          localStorage.setItem("actorType", claims.actorType);
        if (claims.clientId != null)
          localStorage.setItem("clientId", String(claims.clientId));
        if (claims.userId != null)
          localStorage.setItem("userId", String(claims.userId));
        if (Array.isArray(claims.scope))
          localStorage.setItem("scope", JSON.stringify(claims.scope));
        if (claims.terminosCondiciones)
          localStorage.setItem(
            "terminosCondiciones",
            claims.terminosCondiciones,
          );
        if (usuario != null) localStorage.setItem("usuario", usuario);
      }

      window.dispatchEvent(new Event("auth:login"));

      const flag = (claims?.terminosCondiciones || "").toString().toUpperCase();
      const debeAceptarTyC = flag !== "SI";

      if (debeAceptarTyC) {
        navigate("/login/TerminosCondicionesPassword");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      console.error(err);
      setError("Usuario o clave incorrectos");
    }
  };

  return (
    <div className="auth-shell">
      <div
        className="auth-left"
        style={{
          backgroundImage: "url('/imgs/login_new.png')",
          //backgroundSize: "200%",
          backgroundSize: "90%",
          backgroundPosition: "5% center",
        }}
      />

      <div
        className="auth-right"
        style={{
          //backgroundImage: "url('/imgs/login-screen-2_new.png')",
          backgroundSize: "60%",
          backgroundPosition: "50% center",
        }}
      >
        {/* <img src="/imgs/sello.png" alt="Sello" className="auth-stamp" /> */}
        <div className="auth-card" style={{ marginTop: "-2rem" }}>
          {/* Logo superior con dos imágenes */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "0px",
              marginBottom: "1rem",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >{/*
            <img
              src="/imgs/logoFlota.png"
              alt="Logo 1"
              style={{
                width: "200px",
                height: "auto",
                display: "block",
              }}
            />*/}
            <img
              src="/imgs/claim_new.png"
              alt="Logo 2"
              style={{
                width: "325px",
                height: "auto",
                display: "block",
              }}
            />
          </div>

          <h2 className="auth-title">¿Sos cliente Flota?</h2>
          <p className="auth-subtitle">¡Conocé aquí tus movimientos!</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              placeholder="Usuario"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              className="input rounded-full"
            />

            <div className="relative">
              <input
                type={mostrarClave ? "text" : "password"}
                placeholder="Clave"
                value={clave}
                onChange={(e) => setClave(e.target.value)}
                className="input input-with-icon rounded-full"
              />
              <span
                className="input-icon"
                onClick={() => setMostrarClave(!mostrarClave)}
              >
                {mostrarClave ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {error && <p className="form-error">{error}</p>}

            <button
              type="submit"
              className="btn btn-green btn-block rounded-full"
            >
              Ingresar
            </button>
          </form>

          <a href="/nota.docx" download className="text-link text-sm">
            * Solicitud Nuevo Usuario
          </a>

          {/* Contenedor de dos sellos uno al lado del otro */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginTop: "10px",
              justifyContent: "center",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <img
              src="/imgs/flota_logo_last.png"
              alt="Sello 1"
              className="auth-stamp"
              style={{
                width: "130px",
                height: "auto",
                display: "block",
                margin: 0,
              }}
            />
            <img
              src="/imgs/petrobras_logo_last.png"
              alt="Sello 2"
              className="auth-stamp"
              style={{
                width: "150px",
                height: "auto",
                display: "block",
                margin: 0,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
